import fetch from '@/utils/fetch';

const model = {
  state: {
    remindTime: [
      {
        name: '早餐',
      },
      {
        name: '午餐',
      },
      {
        name: '下午茶',
      },
      {
        name: '晚餐',
      },
    ],
    remindInfo: null,
    submitLoading: false,
  },
  reducers: {
    setState(state, partialState) {
      return { ...state, ...partialState };
    },
  },
  actions: ({ dispatch: { orderRemindManage }, getState }) => ({
    // 获取点餐提醒信息
    async getRemindInfo() {
      const data = await fetch('/saasmerchant/fsarea/mealRemind/info', {
        type: 'GET',
      });
      if (data) {
        orderRemindManage.setState({ listLoading: false });
        const remindTime = orderRemindManage.formatHoursToTime(data.remindTime);
        orderRemindManage.setState({ remindInfo: data, remindTime });
      }
    },
    async saveMealRemind(params) {
      orderRemindManage.setState({
        submitLoading: true,
      });
      const remindTime = orderRemindManage.formatRemindTime();
      const data = await fetch('/saasmerchant/fsarea/mealRemind/save', {
        params: {
          ...params,
          remindTime,
        },
        type: 'POST',
        useJson: true,
      });
      orderRemindManage.setState({
        submitLoading: false,
      });
      return data;
    },
    formatRemindTime() {
      const { remindTime } = getState().orderRemindManage;
      return remindTime.map((item) => {
        const { time, ...rest } = item;
        const timeArr = (time && time.split(':')) || [];
        const hours = (timeArr[0] && timeArr[0].replace(/\b(0)/gi, '')) || '';
        const minutes = (timeArr[1] && timeArr[1].replace(/\b(0)/gi, '')) || '0'; // '00'要传'0'
        return {
          ...rest,
          hours,
          minutes,
        };
      });
    },
    formatHoursToTime(remindTime) {
      return remindTime.map((item) => {
        const { hours, minutes, ...rest } = item;
        return {
          ...rest,
          time: `${item.hours}:${item.minutes}`,
        };
      });
    },
    changeMealTime(val, index) {
      const { remindTime } = getState().orderRemindManage;
      remindTime[index].time = val;
      orderRemindManage.setState({ remindTime });
    },
  }),
};

export default model;
